module.exports = __webpack_public_path__ + "static/media/kuokkimista.5d07bfc5.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/kuokkimista.mp4
 ** module id = 457
 ** module chunks = 0
 **/